import { createSlotRecipe } from './runtime';

const cardConfig = {"name":"card","slots":["root","header","body","footer","title","description","root","header","body","footer","title","description"]}

export const card = /* @__PURE__ */ createSlotRecipe(cardConfig)